import { getRoot, types } from 'mobx-state-tree';

const CategoryNode = () =>
  types
    .model('CategoryNode', {
      label: types.string,
      value: types.number,
      checked: false,
      children: types.optional(types.array(types.late(CategoryNode)), []),
    })
    .actions(self => ({
      afterAttach() {
        self.children = getRoot(self)
          .uiStore.catalogStore.categories.filter(
            ({ parentCategoryId }) => parentCategoryId === self.value,
          )
          .map(({ id, name }) => ({ label: name, value: id }));
      },
      unselect() {
        self.checked = false;
      },
      select() {
        self.checked = true;
      },
    }));

export default CategoryNode;
